// extracted by mini-css-extract-plugin
module.exports = {"portal":"styles_portal__1MUVr"};